import {
  isAndroidNative,
  isAndroidWebView,
  isChrome,
  isEdge,
  isFacebook,
  isFF,
  isIE,
  isIOSWebView,
  isMSIE,
  isSafari,
} from '../utils';
import { browserVersion } from '../utils';
import { BrowserVersion } from './models';

export class Browser {

  static get androidNative(): boolean {
    return isAndroidNative();
  }

  static get chrome(): boolean {
    return isChrome();
  }

  static get edge(): boolean {
    return isEdge();
  }

  static get facebook(): boolean {
    return isFacebook();
  }

  static get firefox(): boolean {
    return isFF();
  }

  static get ie(): boolean {
    return isIE();
  }

  static get msie(): boolean {
    return isMSIE();
  }

  static get safari(): boolean {
    return isSafari();
  }

  static get iOSWebView(): boolean {
    return isIOSWebView();
  }

  static get androidWebView(): boolean {
    return isAndroidWebView();
  }

  static get version(): BrowserVersion {
    return browserVersion(this, navigator.userAgent);
  }
}
